import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "@/routes/rootRoute";

export const loginRoute = createRoute({
  path: "/login",
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./Login");
    return { default: m.Login };
  }),
});
